import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/Button";

const StepHeader = ({ title, onAdd, addLabel = "Add",disabled=false }) => {
  return (
    <>
      <div className="flex items-center rounded-md justify-between bg-background-primary mb-3 py-2 px-5">
        <h2 className="text-base font-bold text-text-primary">{title}</h2>

        {onAdd && (
          <Button
            type="button"
            disabled={disabled}
            onClick={onAdd}
            className="flex items-center  gap-2 text-sm font-bold text-button-secondary border border-button-secondary transition bg-background-primary rounded-full"
          >
            <Plus size={18} /> {addLabel}
          </Button>
        )}
      </div>

      <hr className="mb-6 border-border-primary" />
    </>
  );
};

export default StepHeader;
